// import "./App.css";
// import AllServices from "./components/AllServices";
// import { Contact } from "./components/Contact";
// import { Footer } from "./components/Footer";
// import { Hero } from "./components/Hero";
// import Layout from "./components/Layout";
// import { Navbar } from "./components/Navbar";
// import { Products } from "./components/Products";
// import { Services } from "./components/Services";
// import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// function App() {
//   // return (
//   //   <div>
//   //     <Navbar />
//   //     <Hero />
//   //     <Services />
//   //     <Products />
//   //     <Contact />
//   //     <Footer />
//   //   </div>
//   // );
//   return (
//     <Router>
//       <Routes>
//         <Route element={<Layout />}>
//           {/* <Route path="/" element={<Home />} /> */}
//           <Route path="/" element={<Hero />} />
//           <Route path="/services" element={<Services />} />
//           <Route path="/all-services" element={<AllServices />} />
//         </Route>
//       </Routes>
//     </Router>
//   );
// }

// export default App;

import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import { Services } from "./components/Services";
import AllServices from "./components/AllServices";
import Home from "./components/Home";
import AllProducts from "./components/AllProducts";
import { Contact } from "./components/Contact";
import { AboutUs } from "./components/AboutUs";

function App() {
  return (
    <Router>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} /> {/* stacked homepage */}
          <Route path="/services" element={<Services />} />
          <Route path="/all-services" element={<AllServices />} />
          <Route path="/all-products" element={<AllProducts />} />
          <Route path="/all-products" element={<AllProducts />} />
          <Route path="/contact-us" element={<Contact />} />
          <Route path="/about-us" element={<AboutUs />} />
          {/* separate page */}
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
